import type { PreAuthorization } from '@gozoki/api-types'
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { fetchPreAuthorizations } from '../queries/preAuthorizations.queries'

export const usePreAuthorizations = (
  storeId: number,
): UseQueryResult<PreAuthorization[], unknown> =>
  useQuery({
    queryKey: ['pre-authorizations', storeId],
    queryFn: () => fetchPreAuthorizations(storeId),
  })
